// momentjs
import moment from 'moment'
import Cookies from 'js-cookie'

// auth api
import AuthService from '@/api/AuthService'
// shop api
import ShopService from '@/api/ShopService'
// email api
import MailService from '@/api/MailService'
// router
import router from './../../router'
import _ from 'lodash'
// local storeage
const LocalStorage = require('store')

// initial state
const state = {
  auth: {},
}

function setAuth (opts) {
  var auth = LocalStorage.get('auth') || {}
  if (opts.access_token) auth['access_token'] = opts.access_token
  if (opts.refresh_token) auth['refresh_token'] = opts.refresh_token
  if (opts.user_info) auth['user_info'] = opts.user_info
  if (opts.shop_info) auth['shop_info'] = opts.shop_info
  return LocalStorage.set('auth', auth)
}

function getAuth () {
  return LocalStorage.get('auth')
}

function removeAuth (opts) {
  var auth = LocalStorage.get('auth')
  if (opts.access_token) delete auth.access_token
  if (opts.refresh_token) delete auth.refresh_token
  if (opts.user_info) delete auth.user_info
  if (opts.shop_info) delete auth.shop_info
  return LocalStorage.set('auth', auth)
}

function checkAllowToAccess (user_permissions, allow_list, app_id) {
  let is_allow = false
  user_permissions.map(permission => {
    if (permission.app_id == app_id) {
      if (allow_list.indexOf(permission.role) >= 0) {
        is_allow = true
      }
    }
  })
  return is_allow
}

function hasPermission(state, appId, moduleId, submoduleId, roleType) {
  const permissions = state.auth.user_info.permissions
  for (const permission of permissions) {
    if (permission.app_id == appId) {
      for (const module of permission.modules) {
        if (module.module_id == moduleId) {
          if (submoduleId) {
            for (const submodule of module.sub_modules) {
              if (submodule.sub_module_id == submoduleId) {
                return submodule.action[roleType]
              }
            }
          } else {
            return module.action[roleType]
          }
        }
      }
    }
  }
  return false
}

function getPermissions(state, appId, moduleId, submoduleId) {
  const permissions = state.auth.user_info.permissions
  for (const permission of permissions) {
    if (permission.app_id == appId) {
      for (const module of permission.modules) {
        if (module.module_id == moduleId) {
          if (submoduleId) {
            for (const submodule of module.sub_modules) {
              if (submodule.sub_module_id == submoduleId) {
                return submodule.metadata
              }
            }
          } else {
            return module.metadata
          }
        }
      }
    }
  }
  return false
}

// getters
const getters = {
  getAuth: state => state.auth,
  getMe: state => state.auth.user_info,
  getShopInfo: state => state.auth.shop_info,
  getShopInstalledApps: (state) => state.auth.shop_info.install_apps,
  isAppModuleInstalled: (state) => (appId, moduleId) => {
    for (const app of state.auth.shop_info.install_apps) {
      if (app.app_id === appId) {
        for (const module of app.modules) {
          if (module.module_id === moduleId) {
            return true
          }
        }
      }
    }
    return false
  },
  getFreeTrialDaysLeft: (state) => {
    if (state.auth.shop_info.freetrial_end_at == null) {
      return 0
    }
    const now = moment()
    const freetrialEndAt = moment(state.auth.shop_info.freetrial_end_at)
    return freetrialEndAt.diff(now, 'days') + 1
  },
  isFreeTrialLive: (state) => {
    if (state.auth.shop_info.freetrial_end_at == null) {
      return false
    }
    const now = moment()
    const freetrialEndAt = moment(state.auth.shop_info.freetrial_end_at)
    return freetrialEndAt.diff(now) > 0
  },
  getShopSetting: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings
    }
    return null
  },
  getPosSetting: state => {
    if (state.auth.shop_info) {
      if (state.auth.shop_info.settings) {
        if (state.auth.shop_info.settings.apps) {
          if (state.auth.shop_info.settings.apps.pos) {
            return {
              ...state.auth.shop_info.settings.apps.pos,
              receipt: {
                shop_logo: {
                  is_active: state.auth.shop_info.settings.apps.pos.receipt.is_show_logo,
                  value: state.auth.shop_info.logo.thumbnail,
                },
                shop_name: {
                  is_active: state.auth.shop_info.settings.apps.pos.receipt.is_show_name,
                  value: state.auth.shop_info.shop_name,
                },
                shop_address: {
                  is_active: state.auth.shop_info.settings.apps.pos.receipt.is_show_address,
                  value: state.auth.shop_info.info.location.address,
                },
                shop_tax_id: {
                  is_active: state.auth.shop_info.settings.apps.pos.receipt.is_show_tax_id,
                  value: state.auth.shop_info.info.vat.taxpayer_no,
                },
                shop_tax_title: {
                  is_active: state.auth.shop_info.settings.apps.pos.receipt.is_show_tax_title,
                },
                shop_tel: {
                  is_active: state.auth.shop_info.settings.apps.pos.receipt.is_show_tel,
                  value: (() => {
                    const contact = state.auth.shop_info.contacts.find((item) => item.platform === 'tel')
                    return contact ? contact.source : ''
                  })(),
                },
                order_no: state.auth.shop_info.settings.apps.pos.receipt.is_show_order_no,
                customer_name: state.auth.shop_info.settings.apps.pos.receipt.is_show_customer_name,
                text_footer: {
                  is_active: state.auth.shop_info.settings.apps.pos.receipt.text_footer.is_active,
                  value: state.auth.shop_info.settings.apps.pos.receipt.text_footer.value,
                },
                font_size: state.auth.shop_info.settings.apps.pos.receipt.font_size,
              },
            }
          }
        }
      }
    }
    return null
  },
  getPurchaseSetting: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.apps.purchase
    }
    return null
  },
  getSaleSetting: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.apps.sale
    }
    return null
  },
  getAccountSetting: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.apps.account
    }
    return null
  },
  getInventorySetting: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.apps.inventory
    }
    return null
  },
  getPayrollSetting: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.apps.payroll
    }
    return null
  },
  getExpenseSetting: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.apps.expense
    }
    return null
  },
  getBillingPreferenceSetting: state => {
    if (state.auth.shop_info) {
      if (state.auth.shop_info.settings) {
        return state.auth.shop_info.settings.billing.preferences
      }
    }
    return null
  },
  getCurrency: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.general.appearance.currency
    }
    return null
  },
  getDateFormat: state => {
    if (state.auth.shop_info) {
      return state.auth.shop_info.settings.general.appearance.format_date
    }
    return null
  },
  getVat: state => 7,
  getUserCanCreate: (state) => (option) => {
    let user_permissions = state.auth.user_info.permissions
    let allow_list = ['manager', 'user']
    let app_id = option.app_id
    return checkAllowToAccess(user_permissions, allow_list, app_id)
  },
  getUserCanEdit: (state) => (option) => {
    let user_permissions = state.auth.user_info.permissions
    let allow_list = ['manager', 'user']
    let app_id = option.app_id
    return checkAllowToAccess(user_permissions, allow_list, app_id)
  },
  getUserCanDelete: (state) => (option) => {
    let user_permissions = state.auth.user_info.permissions
    let allow_list = ['manager', 'user']
    let app_id = option.app_id
    return checkAllowToAccess(user_permissions, allow_list, app_id)
  },
  getUserCanUpdateStatus: (state) => (option) => {
    let user_permissions = state.auth.user_info.permissions
    let allow_list = ['manager']
    let app_id = option.app_id
    return checkAllowToAccess(user_permissions, allow_list, app_id)
  },
  getRoleView: (state) => (appId, moduleId, submoduleId) => hasPermission(state, appId, moduleId, submoduleId, 'view'),
  getRoleCreate: (state) => (appId, moduleId, submoduleId) => hasPermission(state, appId, moduleId, submoduleId, 'create'),
  getRoleEdit: (state) => (appId, moduleId, submoduleId) => hasPermission(state, appId, moduleId, submoduleId, 'update'),
  getRoleApprove: (state) => (appId, moduleId, submoduleId) => hasPermission(state, appId, moduleId, submoduleId, 'approve'),
  getRoleDelete: (state) => (appId, moduleId, submoduleId) => hasPermission(state, appId, moduleId, submoduleId, 'delete'),
  getMetadata: (state) => (appId, moduleId, submoduleId) => getPermissions(state, appId, moduleId, submoduleId),
}

// mutations
const mutations = {
  Login (state, data) {
    // store user token in the browser
    setAuth({
      access_token: data.access_token,
      refresh_token: data.refresh_token,
      user_info: data.user_info,
    })

    state.auth = getAuth()
  },
  LoginShop (state, data) {
    // store user token in the browser
    setAuth({
      access_token: data.access_token,
      shop_info: data.shop_info,
      refresh_token: data.refresh_token,
      warehouses: data.warehouses,
    })

    state.auth = getAuth()
  },
  Logout (state) {
    // remove user token in browser
    removeAuth({
      access_token: true,
      refresh_token: true,
      user_info: true,
      shop_info: true,
    })

    // set auth
    state.auth = getAuth()
  },
  LogoutShop (state) {
    // state.isLoginShop = false
    removeAuth({
      shop_info: true,
    })

    // set auth
    state.auth = getAuth()
  },
  LoggedIn (state) {
    state.auth = getAuth()
  },
  LoggedInShop (state) {
    state.auth = getAuth()
  },
  setLocalStorageShopInfo (state, shop_info) {
    // store user token in the browser
    setAuth({
      shop_info: shop_info,
    })
    state.auth = getAuth()
  },
  setLocalStorageUserInfo (state, user_info) {
    // store user token in the browser
    setAuth({
      user_info: user_info,
    })
    state.auth = getAuth()
  },
  updateToken (state, data) {
    // store user token in the browser
    setAuth({
      access_token: data.access_token,
      refresh_token: data.refresh_token,
    })
    state.auth = getAuth()
  },
}

// actions
const actions = {
  async Login ({ commit }, data) {
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      // call api
      const response = await AuthService.login(data)

      // stop loading
      this.dispatch('Loading', false)

      let result = response.data

      // success
      if (result.success) {
        // user is owner
        if (result.data.user_info.type == 'owner') {
          // set access_token
          commit('Login', {
            access_token: result.access_token,
            refresh_token: result.refresh_token,
            user_info: result.data.user_info,
          })
          await this.dispatch('getShops')
          const shop = this.getters.getShops[0]
          this.dispatch('LoginShop', {
            shop_id: shop.shop_id,
            token: data.token,
          })
        } else { // user is employee
          // set access_token
          commit('Login', {
            access_token: result.access_token,
            refresh_token: result.refresh_token,
            user_info: result.data.user_info,
          })
          this.dispatch('LoginShop', {
            shop_id: result.data.shop_id,
            token: data.token,
          })
        }
      } else {
        // fail
        this.dispatch('Error', result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', 'เกิดข้อผิดพลาด')
      // stop loading
      this.dispatch('Loading', false)
    }
  },
  async LoginShop ({ commit, dispatch }, data) {
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await AuthService.loginShop({
        shop_id: data.shop_id,
      })

      // stop loading
      this.dispatch('Loading', false)

      let result = response.data

      if (result.success) {
        // set access_token
        commit('LoginShop', {
          access_token: result.access_token,
          refresh_token: result.refresh_token,
          shop_info: result.data.shop_info,
        })

        // set ui option
        this.dispatch('updateUIOptions', LocalStorage.get('uiOptions'))

        // go to homepage
        router.push({
          name: 'Home',
          query: {
            welcome: data.token ? 'onboarding' : '',
          },
        })
      } else {
        console.log('result', result)
        // fail
        removeAuth({
          access_token: true,
          refresh_token: true,
          user_info: true,
          shop_info: true,
        })
        this.dispatch('Error', result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
      // stop loading
      this.dispatch('Loading', false)
    }
  },
  Logout ({ commit }) {
    this.dispatch('setLastRouter', null)
    this.dispatch('clearWarehouses')

    commit('Logout')

    window.location = '/'
  },
  LogoutShop ({ commit }) {
    this.dispatch('setLastRouter', null)
    this.dispatch('clearWarehouses')
    commit('LogoutShop')
  },
  LoggedIn ({ commit }) {
    // get user info
    commit('LoggedIn')
  },
  async LoggedInShop ({ commit }, data) {
    commit('LoggedInShop')

    // set ui options
    this.dispatch('updateUIOptions', LocalStorage.get('uiOptions'))

    // update shop info
    await this.dispatch('setLocalStorageShopInfo')

    // update user info
    await this.dispatch('setLocalStorageUserInfo')
  },
  async Register ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await AuthService.register(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // fail
        if (typeof result.error === 'string') {
          this.dispatch('Error', result.error)
        } else {
          this.dispatch('Error', result.status_message)
        }
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
      // stop loading
      this.dispatch('Loading', false)
    }
    return result
  },
  getUserInfo ({ commit }) {

  },
  async setLocalStorageShopInfo ({ commit }) {
    var result
    try {
      const response = await ShopService.getSelf()

      result = response.data

      if (result.success && result.data !== null) {
        commit('setLocalStorageShopInfo', result.data)

        // set cookies
        const pricingType = _.get(result.data, 'pricing.type') || 'pay_as_you_go'
        Cookies.set('pricing_type', pricingType, {
          domain: '.treesoft.io',
          secure: true,
          sameSite: 'Lax',
          expires: 30, // x days
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async setLocalStorageUserInfo ({ commit }) {
    var result
    try {
      const response = await AuthService.getMe()

      result = response.data

      if (result.success && result.data !== null) {
        // this use was deleted from admin
        if (result.data.is_deleted == true) {
          // logout
          this.dispatch('Logout')
        } else {
          commit('setLocalStorageUserInfo', result.data)
        }
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async checkCandidate ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await AuthService.checkCandidate(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  updateToken ({ commit }, data) {
    commit('updateToken', data)
  },
  async verifyEmailSend ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await MailService.verifySend(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async verifyEmail ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await MailService.verifyCheck(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async forgotPasswordSend ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await MailService.forgotPasswordSend(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async forgotPasswordCheck ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await MailService.forgotPasswordCheck(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async resetPassword ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await AuthService.resetPassword(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth.js